import React, { useEffect, useState } from 'react';
import axios from 'axios';
import API_URL from '../../config';

// Recruiter dropdown on the candidate edit form, shown only to admins and GV (see canReassign).
// Saving goes through POST /api/reassign/candidate/:id, not the candidate PUT, so the move is
// recorded (undoable from the candidate's timeline) and the open tasks follow the candidate.
export default function RecruiterField({ value, currentId, currentName, onChange }) {
  const [targets, setTargets] = useState([]);
  useEffect(() => {
    axios.get(`${API_URL}/api/reassign/targets`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then(r => setTargets(r.data)).catch(() => setTargets([]));
  }, []);
  const currentListed = targets.some(t => String(t.id) === String(currentId));
  return (
    <div className="form-group">
      <label>Recruiter</label>
      <select value={value || ''} onChange={e => onChange(e.target.value)}>
        {!currentListed && currentId && <option value={currentId}>{currentName || 'Current recruiter'} (locked)</option>}
        {targets.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
      </select>
      <small style={{ color: 'var(--text2)', fontSize: 11 }}>Changing this moves the candidate's open tasks and future automated texts to the new recruiter.</small>
    </div>
  );
}

// Call after the candidate PUT succeeds. No-op unless the recruiter was changed.
export async function reassignIfChanged(candidate, newRecruiterId) {
  if (!candidate || !newRecruiterId || String(newRecruiterId) === String(candidate.recruiter_id)) return;
  await axios.post(`${API_URL}/api/reassign/candidate/${candidate.id}`, { toRecruiterId: Number(newRecruiterId) },
    { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
}
